var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBorehole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    x: 0,
    y: 0,
    viewBox: "0 0 682.667 682.667",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V0H0Z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 682.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 29.077-2.394 25.991 34.165c.029.029.029.029.057.029v41.777l-31.548.529-23.52-32.33s-.029 0-.057-.028z",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(228.423 217.894)",
    fill: "#f9f7f8",
    "data-original": "#f9f7f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 28.243-2.191L55.068 31.8c.029 0 .029.029.057.029v46.227L27.91 94.475 0 78.056Z",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(228.423 377.858)",
    fill: "#f9f7f8",
    "data-original": "#f9f7f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 33.243 3.457 21.825 28.314.057.057v41.749l-26.215 1.88L.057 41.805c0-.029-.029-.029-.057-.057Z",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(228.423 297.876)",
    fill: "#f9f7f8",
    "data-original": "#f9f7f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c13.576 21.37 27.548 32.367 27.548 83.752v23.609L-5 105.873l-22.435-30.256C-26.018 31.12-12.839 20.18 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(256 104.127)",
    fill: "#f9f7f8",
    "data-original": "#f9f7f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 54.983 31.744 16.495 9.524c7.878 4.534 10.599 14.709 6.064 22.588-4.534 7.879-14.68 10.6-22.559 6.093-.028 0-.028 0-.057-.028L-.142 38.149l-16.495-9.523c-7.879-4.563-10.599-14.737-6.036-22.617C-18.139-1.87-7.964-4.591-.085-.057z",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(228.565 179.744)",
    fill: "#375e7d",
    "data-original": "#375e7d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 55.068 31.801 16.495 9.523c7.879 4.563 10.6 14.738 6.065 22.617-4.535 7.851-14.681 10.6-22.56 6.093l-.057-.056L-.057 38.206l-16.494-9.523c-7.879-4.563-10.6-14.738-6.037-22.618C-18.053-1.785-7.936-4.534-.057-.028z",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(228.48 259.67)",
    fill: "#375e7d",
    "data-original": "#375e7d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 55.068 31.772 16.495 9.524c7.879 4.562 10.6 14.737 6.065 22.617-4.535 7.851-14.681 10.6-22.56 6.094-.028 0-.028-.029-.057-.029l-55.068-31.8-16.494-9.524c-7.879-4.534-10.6-14.709-6.037-22.617C-18.053-1.813-7.936-4.534-.057-.057z",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(228.48 339.68)",
    fill: "#375e7d",
    "data-original": "#375e7d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h78.762c13.349 0 24.289 10.911 24.289 24.261v19.414c0 2.693-2.211 4.875-4.904 4.875H-43.022a4.874 4.874 0 0 1-4.875-4.875V24.261C-47.897 10.911-36.986 0-23.637 0Z",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(228.423 455.914)",
    fill: "#375e7d",
    "data-original": "#375e7d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-4.535 7.851-14.681 10.6-22.56 6.094-.028 0-.028-.03-.057-.03L-50.08-9.807c7.879 4.506 17.997 1.786 22.532-6.093 4.563-7.879 1.842-18.055-6.036-22.618l11.024 6.377 16.495 9.524C1.814-18.055 4.535-7.88 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(306.108 403.594)",
    fill: "#2b4d66",
    "data-original": "#2b4d66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-4.535 7.851-14.681 10.6-22.56 6.093l-.057-.057L-50.08-9.807c7.879 4.506 17.997 1.757 22.532-6.093 4.563-7.879 1.842-18.055-6.036-22.618l11.024 6.377 16.495 9.524C1.814-18.055 4.535-7.88 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(306.108 323.611)",
    fill: "#2b4d66",
    "data-original": "#2b4d66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-4.535 7.879-14.681 10.6-22.56 6.093-.028 0-.028 0-.057-.029L-50.08-9.778c7.879 4.477 17.997 1.757 22.532-6.094 4.563-7.879 1.842-18.083-6.036-22.617l11.024 6.377 16.495 9.523C1.814-18.055 4.535-7.88 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(306.108 243.6)",
    fill: "#2b4d66",
    "data-original": "#2b4d66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-27.548v-46.227l-.085-.029-.114-.085V-62.24l.227.113L-.057-46.256c.029 0 .029.029.057.029z",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(283.548 455.914)",
    fill: "#e5e4ec",
    "data-original": "#e5e4ec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-16.722-9.637v-41.748l.227.114 27.463 15.842.057.057V6.377Z",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(272.523 365.076)",
    fill: "#e5e4ec",
    "data-original": "#e5e4ec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-16.722-9.637v-41.776l.227.142 27.463 15.842c.029.029.029.029.057.029V6.377Z",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(272.523 285.094)",
    fill: "#e5e4ec",
    "data-original": "#e5e4ec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-16.523-9.552v-7.68c0-3.43-.085-6.661-.199-9.722v-.057c-1.049-26.953-6.518-41.323-13.575-53.198 4.222-7.114 9.012-13.321 13.774-20.775 13.575 21.37 27.548 32.367 27.548 83.752V6.377Z",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(272.523 205.111)",
    fill: "#e5e4ec",
    "data-original": "#e5e4ec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-27.548a4.874 4.874 0 0 0 4.875-4.875v-19.414c0-13.35-10.912-24.261-24.261-24.261h27.548c13.349 0 24.289 10.911 24.289 24.261v19.414C4.903-2.182 2.692 0 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(326.57 504.464)",
    fill: "#2b4d66",
    "data-original": "#2b4d66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c7.567-3.004 15.985-4.648 24.855-4.648 8.843 0 17.261 1.644 24.828 4.648 7.567 2.977 15.985 4.648 24.856 4.648 8.871 0 17.288-1.671 24.856-4.648 7.538-3.004 15.956-4.648 24.798-4.648v99.963l-83.438 24.602-83.466-24.602V2.296c5.64 1.53 11.62 2.352 17.856 2.352C-15.985 4.648-7.567 2.977 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(380.25 180.68)",
    fill: "#dc8758",
    "data-original": "#dc8758"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v93.02l-95.568 17.005-71.336-17.005V-6.944c8.871 0 17.26 1.644 24.799 4.648 7.567 2.977 15.984 4.649 24.855 4.649S-99.961.681-92.394-2.296c7.567-3.004 15.985-4.648 24.856-4.648 8.871 0 17.288 1.644 24.855 4.648 7.568 2.977 15.985 4.649 24.856 4.649C-11.62 2.353-5.612 1.53 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(174.433 182.976)",
    fill: "#dc8758",
    "data-original": "#dc8758"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h166.904v44.526c0 2.579-2.097 4.677-4.648 4.677H5.47c-3.004 0-5.47-2.466-5.47-5.47Z",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(7.528 275.995)",
    fill: "#b1e4f9",
    "data-original": "#b1e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-44.526h166.904V-.793c0 3.004-2.466 5.47-5.47 5.47H4.676A4.681 4.681 0 0 1 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(337.54 320.522)",
    fill: "#b1e4f9",
    "data-original": "#b1e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-126.12A254.995 254.995 0 0 0-95.2-49.203H5.47V-5.47C5.47-2.466 3.004 0 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(498.973 325.198)",
    fill: "#75cef8",
    "data-original": "#75cef8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-100.67c12.726-26.5 21.002-55.579 23.864-86.188.765.283 1.559.566 2.296.849 7.567 3.005 15.985 4.649 24.855 4.649 8.871 0 17.289-1.644 24.856-4.649C-17.26-88.314-8.843-89.958 0-89.987z",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(504.443 275.995)",
    fill: "#c86d35",
    "data-original": "#c86d35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-8.871 0-17.289 1.673-24.856 4.648-7.567 3.005-15.985 4.649-24.855 4.649-8.872 0-17.289-1.644-24.856-4.649C-82.106 1.673-90.495.029-99.366 0v-114.021l99.423-19.5 102.256 19.5c-21.001 14.794-34.775 39.226-34.775 66.69V6.973c-5.612 1.53-11.62 2.324-17.827 2.324-8.871 0-17.288-1.644-24.856-4.649C17.288 1.673 8.871 0 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(106.894 186.008)",
    fill: "#ffd772",
    "data-original": "#ffd772"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-54.304c0-27.464-13.774-51.895-34.747-66.69l104.099-19.499 97.552 19.499V-6.973c-8.842.03-17.26 1.673-24.799 4.649-7.567 3.005-15.984 4.648-24.855 4.648S99.961.681 92.394-2.324C84.827-5.3 76.409-6.973 67.566-6.973c-8.87 0-17.288 1.673-24.855 4.649C35.144.681 26.726 2.324 17.855 2.324 11.62 2.324 5.64 1.53 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(337.54 192.98)",
    fill: "#ffd772",
    "data-original": "#ffd772"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-7.567 3.005-15.985 4.648-24.856 4.648-8.871 0-17.289-1.643-24.855-4.648-.737-.283-1.531-.566-2.296-.85a262.392 262.392 0 0 0 1.133-24.176c0-33.047-6.292-64.65-17.713-93.644h93.386V-4.648C15.956-4.619 7.539-2.976 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(479.644 190.656)",
    fill: "#fbba58",
    "data-original": "#fbba58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-201.651c-13.264-9.353-29.419-14.852-46.792-14.852-17.374 0-33.529 5.499-46.792 14.852h-201.68v-58.952c0-3.032 2.466-5.498 5.47-5.498H-5.47c3.004 0 5.47 2.466 5.47 5.498z",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(504.443 71.986)",
    fill: "#dc8758",
    "data-original": "#dc8758"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-93.386c-9.183-23.354-21.738-45.036-37.014-64.45H-5.47c3.004 0 5.47 2.466 5.47 5.498z",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(504.443 71.986)",
    fill: "#c86d35",
    "data-original": "#c86d35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-.085",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(46.952 146.81)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-.113",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(100.376 141.737)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-.113",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(130.872 112.232)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 .028-.113",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(378.04 150.665)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-.113",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(408.705 113.338)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-.113",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(456.574 141.624)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h201.651m-496.915 0h201.68",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(302.792 71.986)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h166.904m-496.915 0h166.905",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(337.54 275.995)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-57.534c-3.004 0-5.469-2.466-5.469-5.47v-306.694c0-3.032 2.465-5.498 5.469-5.498h485.975c3.005 0 5.471 2.466 5.471 5.498V-5.47c0 3.004-2.466 5.47-5.471 5.47H271.684a4.682 4.682 0 0 1-4.677-4.677v-181.844c0-44.838-36.702-81.542-81.539-81.542-44.864 0-81.567 36.704-81.567 81.542V-4.677c0 2.579-2.097 4.677-4.648 4.677H34.634",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(70.532 325.198)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 71.563 41.295c7.879 4.563 18.053 1.843 22.616-6.065 4.535-7.879 1.814-18.054-6.065-22.588L16.551-28.683c-7.879-4.534-18.053-1.813-22.588 6.066C-10.6-14.737-7.879-4.562 0 0Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(211.929 208.37)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 71.563 41.295c7.879 4.563 18.053 1.843 22.616-6.036 4.535-7.88 1.814-18.055-6.065-22.617L16.551-28.683c-7.879-4.534-18.053-1.813-22.588 6.066C-10.6-14.737-7.879-4.562 0 0Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(211.929 288.353)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 71.563 41.323c7.879 4.535 18.053 1.815 22.616-6.064 4.535-7.88 1.814-18.055-6.065-22.617L16.551-28.654c-7.879-4.563-18.053-1.842-22.588 6.037C-10.6-14.709-7.879-4.534 0 0Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(211.929 368.335)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c5.64 1.53 11.62 2.324 17.855 2.324 8.871 0 17.289-1.643 24.856-4.648C50.278-5.3 58.696-6.973 67.566-6.973c8.843 0 17.261 1.673 24.828 4.649 7.567 3.005 15.985 4.648 24.856 4.648 8.871 0 17.288-1.643 24.855-4.648 7.567-2.976 15.985-4.649 24.856-4.649m-497 0c8.871 0 17.289 1.673 24.827 4.649 7.567 3.005 15.985 4.648 24.856 4.648 8.871 0 17.288-1.643 24.856-4.648 7.567-2.976 15.984-4.649 24.855-4.649s17.289 1.673 24.856 4.649c7.567 3.005 15.985 4.648 24.855 4.648 6.207 0 12.216-.794 17.828-2.324",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(337.54 192.98)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-55.918a4.875 4.875 0 0 1-4.875-4.875v-19.414c0-13.35 10.912-24.261 24.261-24.261H65.866c13.349 0 24.289 10.911 24.289 24.261v19.414C90.155-2.182 87.944 0 85.252 0H33.358",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(241.319 504.464)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v78.056M0-79.982v41.748m0-121.731v41.748m55.125-48.153v-23.609c0-51.385-13.973-62.382-27.548-83.752-12.839 20.179-26.018 31.12-27.435 75.617M55.125-86.388v-41.777m0 121.76v-41.749m0 126.21V31.829",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(228.423 377.858)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorehole);
export default __webpack_public_path__ + "static/media/borehole.3d76a39ae81b8bb6cbd451e8e40f1606.svg";
export { ForwardRef as ReactComponent };